module.exports = __webpack_public_path__ + "img/img_box_standard_detail.ea70d7c6.svg";